import {ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, Inject, NgZone, signal, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ImageViewerData} from './image-viewer-data';
import {CodaltComponent} from '../codalt.component';
import {register} from "swiper/element/bundle";
import {ArticleImage} from "../classes/article-image.class";

register();

@Component({
    selector: 'app-image-viewer-dialog',
    templateUrl: './image-viewer-dialog.component.html',
    styleUrls: ['./image-viewer-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: []
})
export class ImageViewerDialogComponent extends CodaltComponent {
    @ViewChild('swiperRef') swiperComponent?;
    zoomlevel = 1;
    readonly secure = signal<string>('');

    constructor(
        public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageViewerData,
        private dialog: MatDialog,
        private ngZone: NgZone,
        private cdref: ChangeDetectorRef
    ) {
        super();

        if (data.secure) {
            this.secure.set(`secure=${data.secure}&`);
        }
    }

    ngOnInit(): void {
        const index = this.data.viewIndex
        const images = this.data.images.map(image => {
            return {
                id: image.id,
                path: image.path,
                article_id: image.article_id,
                thumb: image.thumb,
                location: image.location
            } as ArticleImage;
        });
        this.data.images = [...images.slice(index, images.length), ...images.slice(0, index)];
    }

    @HostListener('click', ['$event'])
    public click(event) {
        if (event?.target?.localName !== 'img'
            && event?.srcElement?.className.indexOf('wiper-zoom-container') !== -1) {
            this.dialogRef.close();
        }
    }

    onScroll(event: WheelEvent) {
        if (event.deltaY < 0) {
            this.zoomlevel = this.zoomlevel + 1;
            this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
        } else {
            if (this.zoomlevel > 1) {
                this.zoomlevel = this.zoomlevel - 1;
                this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
            } else {
                this.swiperComponent?.nativeElement.swiper.zoom.out();
            }
        }
    }
}

